import { ActionIcon, CopyButton, Group, Stack, Text, Title, Tooltip } from "@mantine/core";
import { IconCopy, IconCopyCheck } from "@tabler/icons-react";
import type { InterviewPrep } from "../../types/api";
import { PREP_SECTION_KEYS, PREP_SECTION_LABELS } from "../../constants/recruiterAi";
import { axioTokens } from "../../theme";
import { HtmlContent } from "../ui";

const COPY_LABEL = "Copy";
const COPIED_LABEL = "Copied";

export function PrepGuideSections({ prep, compact = false }: { prep: InterviewPrep; compact?: boolean }) {
  return (
    <Stack gap={compact ? "md" : axioTokens.unit[32]}>
      {prep.summary.trim() ? (
        <Text size="sm" lh="var(--axio-line-height-body)">
          {prep.summary}
        </Text>
      ) : null}
      {PREP_SECTION_KEYS.map((key) => (
        <Stack key={key} gap="md">
          <Group justify="space-between" align="flex-start" wrap="wrap" gap="md">
            <Title order={5}>{PREP_SECTION_LABELS[key]}</Title>
            <CopyButton value={prep[key]} timeout={2000}>
              {({ copied, copy }) => (
                <Tooltip label={copied ? COPIED_LABEL : COPY_LABEL}>
                  <ActionIcon variant="subtle" color={copied ? "teal" : "gray"} onClick={copy} aria-label={COPY_LABEL}>
                    {copied ? <IconCopyCheck size="var(--axio-unit-16)" /> : <IconCopy size="var(--axio-unit-16)" />}
                  </ActionIcon>
                </Tooltip>
              )}
            </CopyButton>
          </Group>
          <HtmlContent html={prep[key]} />
        </Stack>
      ))}
    </Stack>
  );
}

export function PrepGuideError({ message }: { message: string }) {
  return (
    <Text size="sm" c="red">
      {message}
    </Text>
  );
}